module.exports = __webpack_public_path__ + "static/media/average_widget_icon.9315268b.svg";